/* 0038a51f169d82593a2e7f59300635ad5f02ace8
 * This file is automatically generated by graphql-let. */

import * as Types from '../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"clientName":"legacy-backend"}}
export type SunsetPreferencesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SunsetPreferencesQuery = { __typename?: 'query', getSPreferences?: { __typename?: 'SPreferencesType', networkFeeWaivedThreshold?: string | null | undefined, accountRecoveryTimelock?: string | null | undefined, sEndDate?: string | null | undefined } | null | undefined };


export const SunsetPreferencesDocument = gql`
    query SunsetPreferences {
  getSPreferences {
    networkFeeWaivedThreshold
    accountRecoveryTimelock
    sEndDate
  }
}
    `;

/**
 * __useSunsetPreferencesQuery__
 *
 * To run a query within a React component, call `useSunsetPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSunsetPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSunsetPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSunsetPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<SunsetPreferencesQuery, SunsetPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SunsetPreferencesQuery, SunsetPreferencesQueryVariables>(SunsetPreferencesDocument, options);
      }
export function useSunsetPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SunsetPreferencesQuery, SunsetPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SunsetPreferencesQuery, SunsetPreferencesQueryVariables>(SunsetPreferencesDocument, options);
        }
export type SunsetPreferencesQueryHookResult = ReturnType<typeof useSunsetPreferencesQuery>;
export type SunsetPreferencesLazyQueryHookResult = ReturnType<typeof useSunsetPreferencesLazyQuery>;
export type SunsetPreferencesQueryResult = Apollo.QueryResult<SunsetPreferencesQuery, SunsetPreferencesQueryVariables>;